var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"cover"},[_c('preloader-component'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h1',[_c('span',{attrs:{"id":"new"}},[_vm._v("Новая")]),_c('span',{attrs:{"id":"space"}},[_vm._v("космическая")]),_c('span',{attrs:{"id":"race"}},[_vm._v("гонка")])])
}]

export { render, staticRenderFns }